import { USStateMapping } from '@rategravity/core-lib/enums';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import MediaQuery from 'react-responsive';
import styles from '../styles/form';
import Autocomplete from './autocomplete';
import { TextField } from './MaskedTextField';

const City = ({ model, onChange }) => (
  <TextField
    value={model.get('city')}
    style={styles.threeQuarters}
    floatingLabelText="City"
    onChange={onChange.bind(null, 'city')}
    autoComplete={model.get('city') || ''}
  />
);

const State = ({ model, onChange }) => (
  <SelectField
    style={styles.threeQuarters}
    maxHeight={300}
    labelStyle={{ paddingLeft: 0 }}
    underlineStyle={{ margin: '-1px 24px -1px 0' }}
    value={model.get('state')}
    floatingLabelText="State"
    onChange={(event, _, payload) => onChange('state', payload)}
  >
    {USStateMapping.map((state, i) => (
      <MenuItem key={i} value={state.abbreviation} primaryText={state.name} />
    ))}
  </SelectField>
);

const Zip = ({ model, onChange }) => (
  <TextField
    value={model.get('zip')}
    validate={(value) => {
      return (value && value.length !== 5) || value !== value.replace(/\D/g, '')
        ? 'Please enter a valid zip code'
        : '';
    }}
    maxLength={5}
    style={styles.oneQuarter}
    floatingLabelText="Zip"
    onChange={onChange.bind(null, 'zip')}
    autoComplete={model.get('zip') || ''}
  />
);

const Address = ({ model, onChange, id, addressLabel = 'Home Address' }) => (
  <div>
    <div style={styles.row}>
      <Autocomplete
        className="private"
        value={model.get('address')}
        id={id}
        type="address"
        floatingLabelText={addressLabel}
        onChange={onChange.bind(null, 'address')}
        onAutocomplete={({ address, city, state, zip, county }) => {
          onChange('address', address);
          onChange('zip', zip);
          onChange('city', city);
          onChange('state', state);
          onChange('county', county);
        }}
      />
      <TextField
        value={model.get('unit')}
        style={styles.oneQuarter}
        floatingLabelText="Unit #"
        onChange={onChange.bind(null, 'unit')}
        // Any string will stop an autocompletion.
        autoComplete="disable-autoComplete"
      />
    </div>

    <MediaQuery maxWidth={719}>
      <div>
        <City model={model} onChange={onChange} />
      </div>
      <div>
        <State model={model} onChange={onChange} />
      </div>
      <div>
        <Zip model={model} onChange={onChange} />
      </div>
    </MediaQuery>
    <MediaQuery minWidth={720}>
      <div style={styles.row}>
        <City model={model} onChange={onChange} />
        <State model={model} onChange={onChange} />
        <Zip model={model} onChange={onChange} />
      </div>
    </MediaQuery>
    <br />
  </div>
);

export default Address;



// WEBPACK FOOTER //
// ./src/components/address.js